// ChatList.js
import React, { useState } from "react";

const ChatList = ({
  contacts,
  selectedContact,
  setSelectedContact,
  contactMessages,
}) => {
  const [searchTerm, setSearchTerm] = useState(""); // State per gestire il testo della search bar
  const maxMessageLength = 34; // Maximum message length

  const formatLastMessage = (message) => {
    if (message.length > maxMessageLength) {
      return {
        text: `${message.substring(0, maxMessageLength)}...`, // Reduce message length and add "..."
        sender: "sent", // Set the sender to 'sent'
      };
    }
    return {
      text: message,
      sender: "sent",
    };
  };

  // Filtra i contatti in base al testo digitato nella search bar
  const filteredContacts = contacts.filter((contact) =>
    contact.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="chat-list-container">
      {/* Lista dei contatti filtrati */}
      <div className="chat-list animated">
        {/* Search bar */}
          <div className="search-bar">
            <span className="material-symbols-rounded">search</span>
            <input
              type="text"
              placeholder="Search contacts"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)} // Aggiorna il valore della search bar
            />
          </div>
        <br></br>

        {filteredContacts.map((contact) => (
          <div
            key={contact.id}
            className={`chat-item ${
              contact === selectedContact ? "selected" : ""
            }`}
            onClick={() => setSelectedContact(contact)}
          >
            <img
              className="contact-avatar"
              src={contact.avatar}
              alt={contact.name}
            />
            <div className="contact-info">
              <div className="contact-name animated">{contact.name}</div>
              <div className="contact-last-message animated">
                {formatLastMessage(contact.lastMessage).text}
              </div>
            </div>
          </div>
        ))}
        {/* Mostra un messaggio se nessun contatto corrisponde */}
        {filteredContacts.length === 0 && (
          <div className="no-contacts">No contact found.</div>
        )}



<div className="bottom-navbar">
        <button className="selected-bottom-navbar">
          <span className="material-symbols-rounded">chat</span>
          Chat
        </button>
        <button className="disabled">
          <span className="material-symbols-rounded">call</span>
          Calls
        </button>
        <button className="disabled">
          <span className="material-symbols-rounded">groups</span>
          Community
        </button>
      </div>
      </div>
    </div>


  );
  
};

export default ChatList;
